import React from 'react'
import { isNumber, values, sortBy } from 'lodash'
import m from 'moment'
import { connect } from 'react-redux'
import { Panel, ButtonGroup, Table, Glyphicon } from 'react-bootstrap'
import { Link, browserHistory } from 'react-router'
import DocumentTitle from "react-document-title"

import { calculateTripPrice, getPaidTotals, getTripCode } from '../../lib/TripTools'
import { getTripsWithPayments, getAllRoutes, getAllActivities, getAllCities, getFromQuery } from '../selectors'
import { updateTrip } from '../ducks/trips.js'
import Button from '../components/Button'
import { getText, getTextWithTokens } from '../lib/text.js'
import { printMoney, maxByKey } from '../../lib/Tools'
import { replaceQuery } from '../lib/AppTools.js'

import PaymentModal from './PaymentModal'

function getPaymentsList(trips, col: string, direction: "ASC"|"DESC"|"NONE", Routes, Activities, Cities) {
  let paymentList = []
  
  const latestPayment = t => maxByKey(t.payments, p => p.sentDate)
  
  let sortedTrips = sortBy(values(trips), t => latestPayment(t).sentDate)
  
  if (col === "trip" && direction == "ASC") {
    sortedTrips = _.reverse(sortedTrips)
  }
  
  sortedTrips.forEach(t => {
    if (col != "sentDate") {
      paymentList.push({
        trip : t, 
        finalPrice: calculateTripPrice(t, Routes[t.mainRoute], Activities, Cities).finalE, 
        totals: getPaidTotals(t)
      })
    }
    t.payments.forEach((payment, idx) => {
      paymentList.push({...payment, trip : t, i : idx, key: `${t._id}-${payment.key}-${idx}`})
    })
  })
  
  if (col === "sentDate") paymentList = sortBy(paymentList, ["sentDate"])
  if (col === "sentDate" && direction == "ASC") paymentList = _.reverse(paymentList)
  
  return paymentList
}

/**
 *
 */

// @TODO props are missing here yo'
type Props = {
  trips: Object
}


class Payments extends React.PureComponent {

  constructor(props) {
    super(props)
    this.state = { editingIdx: null, creating : false, editingTrip : {}}
  }

  props: Props

  closeModal() { this.setState({ editingIdx: null, creating: false }) }

  handleSort(sortColumn) {
    if (sortColumn === this.props.query.sortColumn) {
      replaceQuery(browserHistory, this.props.query, {
        sortDirection: this.props.query.sortDirection === "ASC" ? "DESC" : "ASC"
      })
    }
    else {
      replaceQuery(browserHistory, this.props.query, {
        sortColumn,
        sortDirection: (sortColumn === "trips" || sortColumn === "modification" ? "DESC" : "ASC")
      })
    }
  }

  render() {
    const { trips, Activities, Cities, Routes  } = this.props
    const { sortColumn, sortDirection} = this.props.query


    const MyTh = ({label, col}) => (
      <th
        onClick={() => this.handleSort(col)}
        style={{ textDecoration: sortColumn === col ? "underline" : "none", cursor: "pointer" }}
      >
        <Glyphicon glyph="sort" />{label}
      </th>
    )

    const columns = [
      { key: "trip",       money: false, label: getText("Nombre")                    },
      { key: "name",       money: false, label: getText("Pago")                   },
      { key: "sentDate",       money: false, label: getText("Fecha de transferencia")},
      { key: "paymentMethod",       money: false, label: getText("Método de pago")   },
      { key: "eur",        money: true,  label: getText("€")                         },
      { key: "yuan",       money: true,  label: getText("¥")                         },
      { key: "receivedDate",       money: false, label: getText("Pago recibido")     },
      { key: "receivedEur",      money: true,  label: getText("Recibido (€)")        },
      { key: "comment",    money: false, label: getText("Comentario")                },
    ]
    return (
      <div style={{ padding: 15, margin: "auto", maxWidth: 1250 }}>
        <DocumentTitle title= {`Pagos`} />
        <Panel>
          <Panel.Body>

            <Panel style={{ maxWidth: 800 }} bsStyle="warning">
              <Panel.Body>
                {
                  "⚠️  En esta pantalla se incluyen todos los pagos "
                  + "(recibidos o no) de clientes hasta hace 6 meses (desde "
                    + m().startOf("day").subtract(6, "months").format("YYYY-MM-DD")
                    + ")."
                }
              </Panel.Body>
            </Panel>
            
            <Table bordered striped>
              <thead>
                <tr>
                  <th />
                  {
                    columns.map(c => (
                      (c.key == "sentDate" || c.key == "trip") 
                        ? <MyTh col={c.key} key={c.key} label={c.label} /> 
                        : <th key={c.key}>{c.label}</th>
                    ))
                  }
                </tr>
              </thead>
              <tbody>
                {getPaymentsList(trips, sortColumn, sortDirection, Routes, Activities, Cities).map((row) => (
                  !isNumber(row.i)
                    ? <tr>
                      <td colSpan={10}>
                        <Link
                          to={`/private/trip/${encodeURIComponent(row.trip._id)}?tab=5`}
                          style={{fontWeight: "bold", fontStyle: "italic"}}
                        >
                          {`${row.trip.name} ` || ""}{row.trip.realName || ""}
                        </Link>
                        <span style={{fontWeight: "bold", marginLeft: "50px" }}>PVP: </span>
                        <span style={{ color: row.finalPrice < 0 ? "red" : "black"}}>{printMoney(row.finalPrice)}€  </span>
                        <span style={{fontWeight: "bold", marginLeft: "20px"  }}>Pagado: </span>
                        <span style={{ color: row.totals.eur < 0 ? "red" : "black"}}>{printMoney(row.totals.eur)}€  </span>
                        <span style={{fontWeight: "bold", marginLeft: "20px"  }}>Falta: </span>
                        <span style={{ color: (row.finalPrice - row.totals.eur)  <= 0 ? "green" : "red"}}>{printMoney(row.finalPrice - row.totals.eur)}€</span>
                        <span style={{fontWeight: "bold", marginLeft: "20px"  }}>Nº Factura: </span>
                        <span>{ row.trip.receiptNumber ? `${row.trip.receiptNumber}/${row.trip.receiptYear} (${row.trip.receiptDate})` : "Sin número"}</span>
                        <span style={{fontWeight: "bold", marginLeft: "20px"  }}>Código: </span>
                        <span>{getTripCode(row.trip)}</span>
                      </td>
                    </tr>
                    :
                    <tr key={row.key}>
                      <td>
                        <ButtonGroup>
                          <Button
                            bsSize="xsmall"
                            style={{color: "red"}}
                            glyph="remove"
                            onClick={() => {
                              if (confirm(getTextWithTokens("delete_payment", [row.name])))
                                this.props.updateTrip(row.trip._id, {payments : row.trip.payments.filter((item, j) => j != row.i)})
                            }}
                          />
                          <Button
                            bsSize="xsmall"
                            glyph="pencil"
                            onClick={() => this.setState({ editingIdx: row.i, editingTrip: row.trip})}
                          >
                            {getText("editButton")}
                          </Button>
                        </ButtonGroup>
                      </td>
                      {
                        columns.map(c => (
                          <td key={c.key} className={"ellipsis"} title={c.key == "comment" ? row[c.key] : ""}>
                            {
                              (() => {
                                if (c.key == "trip") {
                                  return <Link to={`/private/trip/${encodeURIComponent(row.trip._id)}?tab=5`} style={{fontWeight: "bold", fontStyle: "italic"}}>{`${row.trip.name} ` || ""}{row.trip.realName || ""}<br /></Link>
                                }
                                else if (c.key == "receivedDate") {
                                  if (row.isReceived) return `✅ ${row[c.key]}`
                                  else return `❌`
                                }
                                else if (c.key == "receivedEur") {
                                  if (row.isReceived) return printMoney(row[c.key])
                                  else return `❌`
                                }
                                else if (c.key == "paymentMethod") {
                                  return row[c.key] ? getText(`method_${row[c.key]}`) : "???"
                                }
                                else if (c.money) {
                                  return printMoney(row[c.key])
                                }
                                else return row[c.key]
                              })()
                            }
                          </td>
                        ))
                      }
                    </tr>
                ))}
              </tbody>
            </Table>

          </Panel.Body>
        </Panel>

        {
          (isNumber(this.state.editingIdx)) && (
            <PaymentModal
              isNewPayment={false}
              payment={this.state.editingTrip.payments[this.state.editingIdx]}
              onChange={changes => {
                this.props.updateTrip(
                  this.state.editingTrip._id, 
                  {
                    payments : this.state.editingTrip.payments.map((p, i) => (i == this.state.editingIdx ? changes : p))
                  }
                )
                this.closeModal()
              }}
              onCancel={() => this.closeModal() }
            />
          )
        }
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  trips: getTripsWithPayments(state, props),
  Routes: getAllRoutes(state, props),
  Activities: getAllActivities(state, props),
  Cities: getAllCities(state, props),
  query: {
    sortDirection: getFromQuery(state, props)("sortDirection") || "ASC",
    sortColumn: getFromQuery(state, props)("sortColumn") || "trip"
  }
})

const mapDispatchToProps = dispatch => ({
  updateTrip: (id, changes) => dispatch(updateTrip(id, changes)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Payments)
